import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useAuth from '../../../../states/hooks/useAuth/useAuth';
import useAxiosBeta from '../../../../states/hooks/useAxiosBeta/useAxiosBeta';
import useEndPoints from '../../../../states/hooks/useEndpoints/useEndpoints';
import { Transaction } from '../../../../types/wallet';
import { TransactionList } from '../../../elements';

type Props = {
    children?: any;
};

const UserTransactionsPage: FC<Props> = ({ children }) => {
    const { id: requestedTransactionId } = useParams();
    const [ selectedTransaction, setSelectedTransaction ] = useState<Transaction>();
    const endpoints = useEndPoints();
    const { data: transactions, refetch } = useAxiosBeta<Transaction[]>(endpoints.user.transactions);
    
    const sortedTransactions = transactions?.sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    });
    
    useEffect(() => {
        if (!!transactions && !!requestedTransactionId) {
            const requestedTransaction = transactions.find((transaction) => transaction.id === requestedTransactionId);
            setSelectedTransaction(requestedTransaction);
        }
    }, [ transactions, requestedTransactionId ])
    
    return (
        <>
            <div className="p-8">
                <div className="mb-6">
                    <div className="pre-heading">Transacties</div>
                    <div className="heading">Overzicht</div>
                </div>
                <TransactionList 
                    transactions={ sortedTransactions } 
                    requestedTransaction={ requestedTransactionId }
                    onRefresh={ refetch }
                />
            </div>
        </>
    )
}

export default UserTransactionsPage;